import { render, staticRenderFns } from "./indexg.vue?vue&type=template&id=2208a4d6&scoped=true&"
import script from "./indexg.vue?vue&type=script&lang=js&"
export * from "./indexg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208a4d6",
  null
  
)

export default component.exports